var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dialog/csv",
    transform: "translate(-60.000000, -63.000000)",
    fill: "#EF3824",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(60.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_error_48px",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.376,0 0,5.37 0,12 C0,18.63 5.376,24 12,24 C18.624,24 24,18.63 24,12 C24,5.37 18.624,0 12,0 Z M13.2,18 L10.8,18 L10.8,15.6 L13.2,15.6 L13.2,18 Z M13.2,13.2 L10.8,13.2 L10.8,6 L13.2,6 L13.2,13.2 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionRed);
export default __webpack_public_path__ + "static/media/attentionRed.216b1829c691cde9de263d9406646f77.svg";
export { ForwardRef as ReactComponent };